import React from "react";

import { withRouter } from "react-router";

import { inject } from "mobx-react";

import styled, { withTheme } from "styled-components";

import locales from "../utils/locales";

import timestamp from "../utils/timestamp";

import LocaleSwitcher from "./LocaleSwitcher";

const Wrapper = styled.div`
  width: 100%;

  position: fixed;

  left: 0;
  bottom: 0;

  @media (orientation: portrait) {
    display: none;
  }
`;

const Copyright = styled.small`
  font-family: "Patrick Hand", cursive;
  font-size: 0.85em;
  text-align: center;
  width: 100%;
  position: relative;
  display: block;
  color: #316a88;

  @media (max-height: 500px) {
    font-size: 0.5em;
  }

  a {
    color: #316a88;
  }
`;

const mapper = (stores, props) => ({
  intl: locales[props.match.params.locale || stores.uiStore.getLocale.get()]
});

export default withRouter(
  withTheme(
    inject(mapper)(({ intl }) => (
      <Wrapper>
        <Copyright dangerouslySetInnerHTML={{ __html: intl.COPYRIGHT }} />
      </Wrapper>
    ))
  )
);



// WEBPACK FOOTER //
// ./src/components/Copyright.js